// extracted by mini-css-extract-plugin
export default {"msgM":"ef17121505"};